import { styled } from 'goober';
import { forwardRef } from 'react';
import { TableTagBadge, TEGroupItem } from './TagEditor';
import { appColors } from './useTheme';
// general:
export var Sidebar = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme;
    return ({
        flexShrink: 0,
        background: theme.colors.neutral.w50,
        paddingTop: '10px',
        borderLeft: "1px solid ".concat(theme.colors.neutral.w300),
        overflow: 'hidden',
        maxHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
    });
});
// tags:
export var TagsSidebarWrapper = styled(Sidebar, forwardRef)(function (_a) {
    var theme = _a.theme;
    return ({
        width: '360px',
    });
});
export var TSGroupWrap = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        padding: '0px 20px',
        maxHeight: '100%',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    });
});
export var TSGroupItem = styled(TEGroupItem)(function (_a) {
    var theme = _a.theme;
    return ({
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '.expand-btn': {
            padding: '2px 10px 0px 0px',
            height: '32px',
            display: 'flex',
            alignItems: 'center',
        },
    });
});
export var TSTableItem = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        minHeight: '32px',
        '.expand-btn': {
            cursor: 'pointer',
            fontSize: '10px',
            padding: '0px 10px 0px 0px',
            height: '32px',
            display: 'flex',
            alignItems: 'center',
        },
    });
});
export var TSTable = styled(TableTagBadge)(function (_a) {
    var theme = _a.theme;
    return ({
        margin: '0px',
    });
});
// comments:
export var CommentsSidebarWrapper = styled(Sidebar, forwardRef)(function () { return ({
    width: '360px',
}); });
export var CSHeader = styled('div')(function () { return ({
    padding: '5px 20px 20px 20px',
}); });
export var Comment = styled('div')(function (_a) {
    var theme = _a.theme, _b = _a.$mention, $mention = _b === void 0 ? false : _b, _c = _a.$addMargins, $addMargins = _c === void 0 ? false : _c;
    return ({
        backgroundColor: '#fff',
        boxShadow: "0px 4px 16px ".concat(theme.boxShadow),
        border: "1px solid ".concat(appColors.neutral.w200),
        borderRadius: '6px',
        borderTop: $mention ? "4px solid ".concat(theme.colors.function.w500) : "1px solid ".concat(theme.borderColor),
        padding: $mention ? '17px 20px 20px' : '20px',
        margin: $addMargins ? '0px 20px 20px' : '0px',
    });
});
export var CommentAvatarBox = styled('div')(function () { return ({
    paddingRight: '11px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
}); });
export var CommentAvatarLine = styled('div')(function () { return ({
    width: '1px',
    backgroundColor: '#E7EAF0',
    flexGrow: 1,
    marginTop: '5px',
}); });
export var CommentStatusOptions = styled('div', forwardRef)(function () { return ({
    position: 'absolute',
    display: 'flex',
    marginTop: '3px',
    borderRadius: '5px',
    flexDirection: 'column',
    backgroundColor: 'white',
    border: '1px solid #E7EAF0',
    zIndex: 10006,
    right: 0,
}); });
export var Message = styled('div')(function () { return ({
    display: 'flex',
    marginBottom: '11px',
    label: {
        margin: 0,
    },
}); });
export var MessageHeader = styled('div')(function () { return ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
}); });
export var MessageDate = styled('label')(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: '11px',
        color: theme.colors.neutral.w700,
    });
});
export var MessageContent = styled('div')(function () { return ({
    margin: 0,
    marginTop: '11px',
}); });
export var ContextCommentsWrap = styled('div', forwardRef)(function () { return ({
    position: 'absolute',
    zIndex: 1,
    overflow: 'auto',
    width: '320px',
}); });
export var ContextAddCommentWrap = styled(ContextCommentsWrap, forwardRef)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: '20px',
        width: '360px',
        boxShadow: "0px 4px 16px ".concat(theme.boxShadow),
        border: "1px solid ".concat(theme.borderColor),
        borderRadius: '6px',
        background: '#fff',
    });
});
export var ShowRepliesBtn = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        cursor: 'pointer',
        alignItems: 'center',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        padding: '0px 0px 15px',
        '&:hover': {
            opacity: 0.6,
        },
    });
});
